function initializeSaizCart() {
        loadCustomer();
        loadSaizWidget();
        setVisitorId();
        observeCartDrawer();
      }
      window.saizWidgetLoaded = false;
      function loadSaizWidget() {
        if (window.saizWidgetLoaded) {
          window.dispatch(new Event("saiz-widget-loader"));
          console.log("ok");
          return;
        }
        window.saizWidgetLoaded = true;
      
        var scriptSrc = "https://saiz-recommender.com/static/js/saiz-widget.js";
        var cssHref = "https://saiz-recommender.com/static/css/saiz-widget.css";

        // If the script is already present, just dispatch the event
        if (document.querySelector('script[src="' + scriptSrc + '"]')) {
          window.dispatch(new Event("saiz-widget-loader"));
        } else {
            var script = document.createElement("script");
            script.src = "https://saiz-recommender.com/static/js/saiz-widget.js"
            script.type = "text/javascript";
            script.defer = true;
            document.head.appendChild(script);
        }
      }
      /**
      * Set visitor ID on Teveo elements
      */
      function setVisitorId() {
        var elements = document.querySelectorAll('div[data-brandcode="straede"]');
        if (!window.shopify_user_session || !window.shopify_user_session.user_id) {
          return;
        }
        elements.forEach(function (el) {
          el.setAttribute("data-visitorid", window.shopify_user_session.user_id);
        });
      }
       /**
        * Load customer session data
        */
        function loadCustomer() {
        var visitorId = localStorage.getItem("saiz_visitor_id");
        window.shopify_user_session = {
          is_logged_in: false,
          user_id: visitorId
        };
        }

        function observeCartDrawer(){
          const drawer = document.querySelector('a[href="/cart"]');
            if (!drawer) {
              return;
            }
            drawer.addEventListener("click", function() {
              const isOpen = drawer.getAttribute("aria-expanded")==="true";
              if (isOpen) {
                loadSaizWidget();
              }
            });
              var observer = new MutationObserver(function () {
              setVisitorId();
              });

              observer.observe(drawer, {
              childList: true,
              subtree: true,
              });
        }
        
initializeSaizCart();